import moment from 'moment';
import React, { useEffect } from 'react';
import { UIDateSlot } from 'types';
interface Props {
	dates: UIDateSlot[];
	times: string[];
	todaysTimes: string[];
	selectedTimeSlot: string;
	setSelectedTimeSlot: React.Dispatch<React.SetStateAction<string>>;
	selectedDateSlot?: UIDateSlot;
}
const TimeSlots = ({ selectedDateSlot, selectedTimeSlot, setSelectedTimeSlot, dates, times, todaysTimes }: Props) => {
	const [finalTimesArray, setFinalTimesArray] = React.useState<string[]>([]);

	useEffect(() => {
		// selectedDateSlot?.fullDate is of today then use today's time slots else all time slots
		const todaysDate = moment().format('YYYY-MM-DD');
		if (todaysDate === moment(selectedDateSlot?.fullDate).format('YYYY-MM-DD')) {
			setFinalTimesArray(todaysTimes);
		} else {
			setFinalTimesArray(times);
		}
	}, [dates, selectedDateSlot, times, todaysTimes]);
	return (
		<div>
			<p className="text-[#111928] text-[14px] font-[500] leading-[21px] font-inter">
				Available slots <span className="text-[red]">*</span>
			</p>
			<div className="mt-[8px]  hide-scrollbar flex gap-[12px] w-full overflow-scroll whitespace-nowrap scroll-smooth">
				{finalTimesArray?.length ? (
					finalTimesArray.map(time => {
						return (
							<div
								onClick={() => {
									if (selectedDateSlot) {
										setSelectedTimeSlot(time);
									}
								}}
								className={`${
									selectedTimeSlot === time
										? 'border-[2px] border-[#7777E7] bg-[#E5F0FF] text-[#7777E7]'
										: 'border-[2px] border-[#C7C9D9] bg-[#F2F2F5] text-[#1C1C28]'
								} cursor-pointer px-[16px] py-[8px] rounded-[8px] text-center`}
							>
								<p className="font-inter text-[14px] font-[500] leading-[21px] mt-[1px]">{time}</p>
							</div>
						);
					})
				) : (
					<span className="italic text-gray-600 text-sm">No Time Slots found</span>
				)}
			</div>
		</div>
	);
};

export default TimeSlots;
